window.$ = window.jQuery = require('jquery');

var Utils = {
  capitalize: function(text) {
    return text.replace(/\b\w/g, function(a) {
        return a.toUpperCase();
    });
  },
  getUrls: function() {
    var app_server_url = 'https://api.parade.pet';
    var contest_url = 'https://contest.parade.pet';
    var chat_signup_url = 'https://share.parade.pet/user/signUpChat';
    if(window.location.protocol === 'file:' || window.location.hostname === 'localhost' || window.location.hostname === 'dev.parade.pet') {
      app_server_url = 'http://dev.parade.pet:1337';
      contest_url = 'https://stage-contest.parade.pet';
      chat_signup_url = 'http://dev.parade.pet:1337/user/signUpChat';
    } else if(window.location.hostname === 'stage.parade.pet') {
      app_server_url = 'https://stage-api.parade.pet';
      contest_url = 'https://stage-contest.parade.pet';
      chat_signup_url = 'https://stage-share.parade.pet/user/signUpChat';
    }
    return {
      app_server_url: app_server_url,
      contest_url: contest_url,
      chat_signup_url: chat_signup_url
    };
  },
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  },
  setCookie: function(name, value, expires) {
    document.cookie = name + '=' + (value || '') + "; path=/; domain:.parade.pet; secure" + expires;
  },
  getCookie: function(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },
  getCookieExpires: function() {
    var date = new Date();
    var days = 7300;
    date.setTime(date.getTime()+(days*24*60*60*1000));
    return '; expires=' + date.toGMTString();
  },
  getUTMparams: function(ele) {
    var utmCampaign;
    if(ele && ele.length > 0) {
      utmCampaign = $('#utm-campaign').html();
    } else {
      utmCampaign = Utils.getParameterByName('utm_campaign');
    };
    var params =  {
      'utm_campaign': utmCampaign,
      'utm_medium': Utils.getParameterByName('utm_medium'),
      'utm_source': Utils.getParameterByName('utm_source')
    };
    if (params.utm_campaign == null || params.utm_campaign == '') {
      params.utm_medium = Utils.getParameterByName('network');
      if (params.utm_medium != null && params.utm_medium != '') {
        params.utm_medium = 'adwords.' + params.utm_medium;
        params.utm_campaign = Utils.getParameterByName('kw');
        params.utm_source = Utils.getParameterByName('adgroup');
      }
    }
    var irClickId = Utils.getParameterByName('irclickid');
    if(!!irClickId) {
      params.utm_campaign = 'impact_radius';
      params.utm_medium = 'affiliate';
      params.utm_source = irClickId;
    }
    return params;
  },
  formatPhone: function(value) {
    var formatted = '';
    var nodash = value.replace(/-/g, '');
    if(!value) return '';
    if(nodash.length <= 3) {
      formatted = value;
    } else if(nodash.length > 3 && nodash.length <= 6) {
      formatted = nodash.substring(0, 3) + '-' + nodash.substring(3);
    } else if(nodash.length > 6) {
      formatted = nodash.substring(0, 3) + '-' + nodash.substring(3, 6) + '-' + nodash.substring(6);
    }
    return formatted;
  },
  upperCase: function(value) {
    if(!value) return "";
    return value.trim().toUpperCase();
  },
  windowSize: function() {
    var window_size = 769;
    var max_320 = window.matchMedia('all and (max-width: 320px)');
    var max_375 = window.matchMedia('all and (max-width: 375px)');
    var max_414 = window.matchMedia('all and (max-width: 414px)');
    var max_768 = window.matchMedia('all and (max-width: 768px)');
    if (max_320.matches)  {
      window_size = 320;
    } else if (max_375.matches) {
      window_size = 375;
    } else if (max_414.matches)  {
      window_size = 414;
    } else if (max_768.matches)  {
      window_size = 768;
    } else {
    }
    return window_size;
  },
  setBannerSize: function(ele) {
    var width = $(window).width();
    var height = $(window).height();
    ele.width(width);
    ele.height(height);
  },
  setAnimationWidth: function(ele) {
    var width = $(window).width();
    if(width <= 768) {
      ele.width(width);
    } else {
      ele.attr('style', null);
    }
  },
  updateSize: function(item) {
    var heights = new Array();
    item.each(function() {
      heights.push($(this).height());
    });
    var max = Math.max.apply(math, heights);
    item.each(function() {
      $(this).css('height', max + 'px');
    });
  },
  shuffle: function(a) {
		if (a == null) return null;
		var j, x, i;
		for (i = a.length; i; i--) {
			j = Math.floor(Math.random() * i);
			x = a[i - 1];
			a[i - 1] = a[j];
			a[j] = x;
		}
  },
  getEntries: function() {
    var urls = {
      all: 'https://api.parade.pet/entries/trending?limit=100&end=90',
      dogs: 'https://api.parade.pet/entries/trending?limit=100&pettype=1&end=90',
      cats: 'https://api.parade.pet/entries/trending?limit=100&pettype=2&end=90',
      birds: 'https://api.parade.pet/entries/recent?limit=20&pettype=3&end=360',
      horses: 'https://api.parade.pet/entries/recent?limit=20&pettype=4&end=360',
      pigs: 'https://api.parade.pet/entries/recent?limit=20&pettype=5&end=360',
      bunnies: 'https://api.parade.pet/entries/recent?limit=20&pettype=8&end=360'
    };
    var tasks = [];
    $.each(urls, function(key, value) {
      tasks.push(
        $.ajax({
          url: value,
          type: 'get'
        })
      );
    });
    return $.when.apply($, tasks)
  },
  getReferral: function(friendCode) {
    return $.ajax({
      url: 'https://api.parade.pet/v2/referrer/' + friendCode,
      type: 'get'
    });
  },
  redirectUser: function(url) {
    window.location = url;
  }, getLatestPrizes: function() {
    return $.ajax({
      url: 'https://api.parade.pet/v2/website/latestPrizes',
      //url: 'http://dev.parade.pet:1337/v2/website/latestPrizes',
      type: 'get'
    });
  },
  isInViewPort: function(e) {
    var eleTop = e.offset().top;
    var eleBottom = eleTop + e.outerHeight();
    var viewTop = $(window).scrollTop();
    var viewBottom = viewTop + $(window).height();
    return eleBottom > viewTop && eleTop < viewBottom;
  }
};

module.exports = Utils;
